/// <amd-module name="SecurityRoles/Client/RestClient/SecurityRoles" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   distributedtask\web\extensions\vss-distributedtask-web\common\securityroles-client\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as SecurityRoles from "SecurityRoles/Client/Contracts/SecurityRoles";

export interface ISecurityRolesRestClient extends IVssRestClient {
    /**
     * @param scopeId - 
     * @param resourceId - 
     * @param inheritPermissions - 
     */
    changeInheritance(scopeId: string, resourceId: string, inheritPermissions: boolean): Promise<void>;
    /**
     * Get role assignments for the resource
     * 
     * @param scopeId - Id of the assigned scope
     * @param resourceId - Id of the resource that is assigned the scope
     */
    getRoleAssignments(scopeId: string, resourceId: string): Promise<SecurityRoles.RoleAssignment[]>;
    /**
     * Remove the role assignment on a resource
     * 
     * @param scopeId - Id of the assigned scope
     * @param resourceId - Id of the resource on which the role is to be removed
     * @param identityId - Identity on which the assignment is to be removed
     */
    removeRoleAssignment(scopeId: string, resourceId: string, identityId: string): Promise<void>;
    /**
     * @param identityIds - 
     * @param scopeId - 
     * @param resourceId - 
     */
    removeRoleAssignments(identityIds: string[], scopeId: string, resourceId: string): Promise<void>;
    /**
     * Set role assignment on a resource
     * 
     * @param roleAssignment - Roles to be assigned
     * @param scopeId - Id of the assigned scope
     * @param resourceId - Id of the resource on which the role is to be assigned
     * @param identityId - 
     */
    setRoleAssignment(roleAssignment: SecurityRoles.UserRoleAssignmentRef, scopeId: string, resourceId: string, identityId: string): Promise<SecurityRoles.RoleAssignment>;
    /**
     * Set role assignments on a resource
     * 
     * @param roleAssignments - Roles to be assigned
     * @param scopeId - Id of the assigned scope
     * @param resourceId - Id of the resource on which the role is to be assigned
     * @param limitToCallerIdentityDomain - 
     */
    setRoleAssignments(roleAssignments: SecurityRoles.UserRoleAssignmentRef[], scopeId: string, resourceId: string, limitToCallerIdentityDomain?: boolean): Promise<SecurityRoles.RoleAssignment[]>;
    /**
     * @param scopeId - 
     */
    getRoleDefinitions(scopeId: string): Promise<SecurityRoles.SecurityRole[]>;
}

class SecurityRolesRestClient extends RestClientBase implements ISecurityRolesRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param scopeId - 
     * @param resourceId - 
     * @param inheritPermissions - 
     */
    public async changeInheritance(
        scopeId: string,
        resourceId: string,
        inheritPermissions: boolean
        ): Promise<void> {

        const queryValues: any = {
            inheritPermissions: inheritPermissions
        };

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/securityroles/scopes/{scopeId}/roleassignments/resources/{resourceId}/{identityId}",
            routeValues: {
                scopeId: scopeId,
                resourceId: resourceId
            },
            queryParams: queryValues
        });
    }

    /**
     * Get role assignments for the resource
     * 
     * @param scopeId - Id of the assigned scope
     * @param resourceId - Id of the resource that is assigned the scope
     */
    public async getRoleAssignments(
        scopeId: string,
        resourceId: string
        ): Promise<SecurityRoles.RoleAssignment[]> {

        return this.beginRequest<SecurityRoles.RoleAssignment[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/securityroles/scopes/{scopeId}/roleassignments/resources/{resourceId}/{identityId}",
            routeValues: {
                scopeId: scopeId,
                resourceId: resourceId
            }
        });
    }

    /**
     * Remove the role assignment on a resource
     * 
     * @param scopeId - Id of the assigned scope
     * @param resourceId - Id of the resource on which the role is to be removed
     * @param identityId - Identity on which the assignment is to be removed
     */
    public async removeRoleAssignment(
        scopeId: string,
        resourceId: string,
        identityId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/securityroles/scopes/{scopeId}/roleassignments/resources/{resourceId}/{identityId}",
            routeValues: {
                scopeId: scopeId,
                resourceId: resourceId,
                identityId: identityId
            }
        });
    }

    /**
     * @param identityIds - 
     * @param scopeId - 
     * @param resourceId - 
     */
    public async removeRoleAssignments(
        identityIds: string[],
        scopeId: string,
        resourceId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/securityroles/scopes/{scopeId}/roleassignments/resources/{resourceId}/{identityId}",
            routeValues: {
                scopeId: scopeId,
                resourceId: resourceId
            },
            body: identityIds
        });
    }

    /**
     * Set role assignment on a resource
     * 
     * @param roleAssignment - Roles to be assigned
     * @param scopeId - Id of the assigned scope
     * @param resourceId - Id of the resource on which the role is to be assigned
     * @param identityId - 
     */
    public async setRoleAssignment(
        roleAssignment: SecurityRoles.UserRoleAssignmentRef,
        scopeId: string,
        resourceId: string,
        identityId: string
        ): Promise<SecurityRoles.RoleAssignment> {

        return this.beginRequest<SecurityRoles.RoleAssignment>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/securityroles/scopes/{scopeId}/roleassignments/resources/{resourceId}/{identityId}",
            routeValues: {
                scopeId: scopeId,
                resourceId: resourceId,
                identityId: identityId
            },
            body: roleAssignment
        });
    }

    /**
     * Set role assignments on a resource
     * 
     * @param roleAssignments - Roles to be assigned
     * @param scopeId - Id of the assigned scope
     * @param resourceId - Id of the resource on which the role is to be assigned
     * @param limitToCallerIdentityDomain - 
     */
    public async setRoleAssignments(
        roleAssignments: SecurityRoles.UserRoleAssignmentRef[],
        scopeId: string,
        resourceId: string,
        limitToCallerIdentityDomain?: boolean
        ): Promise<SecurityRoles.RoleAssignment[]> {

        const queryValues: any = {
            limitToCallerIdentityDomain: limitToCallerIdentityDomain
        };

        return this.beginRequest<SecurityRoles.RoleAssignment[]>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/securityroles/scopes/{scopeId}/roleassignments/resources/{resourceId}/{identityId}",
            routeValues: {
                scopeId: scopeId,
                resourceId: resourceId
            },
            queryParams: queryValues,
            body: roleAssignments
        });
    }

    /**
     * @param scopeId - 
     */
    public async getRoleDefinitions(
        scopeId: string
        ): Promise<SecurityRoles.SecurityRole[]> {

        return this.beginRequest<SecurityRoles.SecurityRole[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/securityroles/scopes/{scopeId}/roledefinitions",
            routeValues: {
                scopeId: scopeId
            }
        });
    }

}

export const SecurityRolesClientName = "dt.vssf.security-roles.client.ISecurityRolesRestClient";

export function getSecurityRolesClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ISecurityRolesRestClient {
    return pageContext.getRestClient<ISecurityRolesRestClient>(SecurityRolesClientName, options);
}

RestClients.add(SecurityRolesClientName, { 
    factory: SecurityRolesRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
